import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class FlowLayoutItemViewModel extends ControlViewModel {

    /**
     * Das Factory-Tuple
     */
    public tuple: any;

    /**
     * Das ViewModel für die FlowLayoutItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.tuple = this.paramOrDefault(params.tuple, null);
    }
}

ComponentManager.setViewModel('FlowLayoutItemViewModel', FlowLayoutItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');